import mixpanel from 'mixpanel-browser';

// Initialize Mixpanel
const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || 'cabe92f92d2fc2c66e645183598fa168';

// Create a safe wrapper for mixpanel
const safeMixpanel = {
  track: (eventName: string, properties?: any) => {
    if (MIXPANEL_TOKEN) {
      try {
        mixpanel.track(eventName, properties);
      } catch (error) {
        console.error('Mixpanel track error:', error);
      }
    } else {
      console.log('Mixpanel disabled - event not tracked:', eventName, properties);
    }
  },
  identify: (userId: string) => {
    if (MIXPANEL_TOKEN) {
      try {
        mixpanel.identify(userId);
      } catch (error) {
        console.error('Mixpanel identify error:', error);
      }
    } else {
      console.log('Mixpanel disabled - user not identified:', userId);
    }
  },
  people: {
    set: (properties: any) => {
      if (MIXPANEL_TOKEN) {
        try {
          mixpanel.people.set(properties);
        } catch (error) {
          console.error('Mixpanel people.set error:', error);
        }
      } else {
        console.log('Mixpanel disabled - user properties not set:', properties);
      }
    }
  },
  reset: () => {
    if (MIXPANEL_TOKEN) {
      try {
        mixpanel.reset();
      } catch (error) {
        console.error('Mixpanel reset error:', error);
      }
    } else {
      console.log('Mixpanel disabled - reset not performed');
    }
  },
  register: (properties: Record<string, any>) => {
    if (MIXPANEL_TOKEN) {
      try {
        mixpanel.register(properties);
      } catch (error) {
        console.error('Mixpanel register error:', error);
      }
    }
  },
  people_set_once: (properties: Record<string, any>) => {
    if (MIXPANEL_TOKEN) {
      try {
        mixpanel.people.set_once(properties);
      } catch (error) {
        console.error('Mixpanel people.set_once error:', error);
      }
    }
  }
};

if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV === 'development',
    track_pageview: false,
    persistence: 'cookie',
    cross_subdomain_cookie: true,
  });
  //console.log('Mixpanel initialized with token');
} else {
  console.warn('Mixpanel token not found. Analytics will be disabled.');
}

export default safeMixpanel; 